import * as React from 'react';

import { NumeralDisplay } from '../../Fields';
import { NumericalReadOnlyViewProps } from '../types';

export const TotalConstructionCostsReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay title={'Total construction costs'} before={'$'} value={props.value} />
);
